/**
 * Shared playback session — one jukebox state per server instance.
 * Progress is an absolute timeline: anchor + server clock.
 */
import { z } from "zod";
import { QueueEntrySchema } from "./queue.js";
import { NowPlayingSchema } from "./nowPlaying.js";
export const PlaybackNormalizationSchema = z.object({
    enabled: z.boolean(),
    preampDb: z.number().min(-12).max(6),
});
export const PlaybackSnapshotSchema = z.object({
    revision: z.number().int().nonnegative(),
    timelineRevision: z.number().int().positive().default(1),
    serverTimeMs: z.number().nonnegative(),
    anchorPositionSec: z.number().nonnegative(),
    anchorServerTimeMs: z.number().nonnegative(),
    queue: z.array(QueueEntrySchema),
    currentIndex: z.number().int().nonnegative(),
    /** Compatibility: position computed at serverTimeMs. */
    currentTime: z.number().nonnegative(),
    isPaused: z.boolean(),
    nowPlaying: NowPlayingSchema.nullable(),
    activeOwners: z.record(z.string(), z.boolean()),
    normalization: PlaybackNormalizationSchema.default({
        enabled: false,
        preampDb: -6,
    }),
});
export const PlaybackPlayBodySchema = z.object({
    index: z.number().int().nonnegative().optional(),
});
export const PlaybackSeekBodySchema = z.object({
    currentTime: z.number().nonnegative(),
});
export const PlaybackPauseBodySchema = z.object({
    currentTime: z.number().nonnegative().optional(),
});
export const PlaybackActiveOwnersBodySchema = z.object({
    activeOwners: z.record(z.string(), z.boolean()),
});
export const PlaybackSettingsBodySchema = z.object({
    normalization: PlaybackNormalizationSchema.partial().optional(),
});
export const PlaybackEndedBodySchema = z.object({
    trackId: z.number().int().nonnegative(),
    timelineRevision: z.number().int().positive(),
});
//# sourceMappingURL=playback.js.map